import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    enabled: Boolean,
  }

  connect() {
    queueMicrotask(() => {
      // On initial page load, only apply explicit opt-out.
      // Dispatching "enable" here can cause a duplicate prompt on cold start.
      if (!this.enabledValue) this.dispatch("disable")
    })
  }

  toggle(event) {
    if (event.detail?.enabled) {
      this.dispatch("enable")
      return
    }

    this.dispatch("disable")
  }
}
